'use strict';

angular.module('whatchlistController', [])

.controller('WatchlistController', ['appInfo', '$scope', '$rootScope', '$log', '$location', '$window','AgencyService', 'BuyerService', 'CommonService',
    function (appInfo, $scope, $rootScope, $log, $location, $window, AgencyService, BuyerService, CommonService) {    

    $scope.page = 'watchList';
    var currentUser = $rootScope.currentUser;
    $scope.enquiry = {};
    $scope.propertyDetail = {};
    $scope.openHomeDetail = {};
    $scope.notifications = [];
    
    $scope.currentPageSection = 'list';  //can be propertyDetail, enquiryForm depending upon what section is displayed
    $scope.previousPageSection = 'list';
    $scope.showWeeklyRentReturn = false;
    $scope.weeklyRentReturn = '';    
    
    $scope.watchlistProperties = [{}];
    $scope.propertyRefs = [];
    $scope.propertyMicrositeURL = {};
    //  $scope.activeAgency = $rootScope.currentUser.activeAgency;
    $rootScope.header.show = false;
   
    var loadWatchlist = function() {
        var upstreamCall = true;
        if(!$rootScope.loading) {
            $rootScope.loading = true;
            upstreamCall = false;
        }
        BuyerService.getWatchlist()
        .then(function(data){
            $scope.propertyRefs = [];
            $scope.watchlistProperties = data;
            angular.forEach($scope.watchlistProperties, function(watchlist){
                $scope.propertyRefs.push(watchlist.property.propertyRef);
            });
            return BuyerService.getPropertyMicrositeURL($scope.propertyRefs);  
        })
        .then(function(data) {
            $scope.propertyMicrositeURL = data;
        })
        .catch(function(err) {
            console.log(err);
        })
        .finally(function(data) {
            // loadPreferences();
            if (!upstreamCall) {
                $rootScope.loading = false;
            }
        });

        //load preferences from db
      
    }

    var init = function() {
        $scope.enquiry = {};
        $scope.currentPageSection = 'list';
        $scope.previousPageSection = 'list';
        
        $scope.propertyDetail = {};

        loadWatchlist();
    }

  
    $scope.removeFromWatchlist = function(watchlist) {
        $rootScope.loading = true;
        BuyerService.removeFromWatchlist(watchlist.id)
        .then(function(data){
            // property.watched = false;
            // property.watchlistId = 0;
            loadWatchlist();
        })
        .catch(function(err){
            console.log(err);
        })
        .finally(function(err){
            $rootScope.loading = false;
        })
    }

    $scope.displayPageSection =  function(section) {
      return (section == $scope.currentPageSection);
    }

    $scope.showPageSection = function(watchlist, section) {
        var property = watchlist.property;
        $scope.page = section;
        $scope.previousPageSection = $scope.currentPageSection;
        $scope.currentPageSection = section;
        $scope.propertyDetail = property;
        $scope.notifications = watchlist.notifications;
        $scope.openHomeDetail  = {};
        if(watchlist.property.openHome[0].length) {
            $scope.openHomeDetail = watchlist.property.openHome[0][0];
        }
    }

    $scope.hidePageSection = function() {
        var previousPage = $scope.currentPageSection;
        $scope.page = 'watchList';
        $scope.currentPageSection = $scope.previousPageSection;
        $scope.previousPageSection = previousPage;
        $scope.propertyDetail = {};
        $scope.openHomeDetail = {};
        $scope.notifications = [];
    }

    $scope.displayWeeklyRentReturn = function(property) {
        var propertyAddress = property.streetUnit + ' '  + property.streetRef + ' ' + property.streetName + ' ' + property.streetType; 
        var noteText = "Buyer clicked approximate rent return for the property: " + propertyAddress;
        BuyerService.addNote(noteText)
        .then(function(data){
            $scope.showWeeklyRentReturn = true;
            $scope.weeklyRentReturn = property.weeklyRentReturn;    
        })
        .catch(function(err){
            console.log(err);
        })
        .finally(function(data){

        });
    }

    $scope.getPropertyURL = function(propertyRef) {
        var propertyURL = 'http://www.wiseberry.com.au/property/' + propertyRef;
        if($scope.propertyMicrositeURL[propertyRef]) {
            propertyURL = $scope.propertyMicrositeURL[propertyRef];
        }
        return propertyURL;
    }

    init();

}]);